<template>
    <div class="merged-contacts-modal modal-card">
        <header class="modal-card-head">
            <p class="title modal-card-title">{{ title || 'Merged items' }}</p>
        </header>
        <section class="modal-card-body">
                <o-table
                    v-if="isTableVisible"
                    :data="data"
                    :detail-transition="transitionName"
                    :detailed="table.detailed"
                    :loading="loading"
                    :opened-detailed="defaultOpenedDetails"
                    :show-detail-icon="showDetailIcon"
                    :total="total"
                    aria-next-label="Next page"
                    aria-previous-label="Previous page"
                    aria-page-label="Page"
                    aria-current-label="Current page"
                    class="merged-contacts-table fullwidth-table"
                    custom-detail-row
                    detail-key="id"
                    ref="table"
                    >
                    <template>
                        <o-table-column #default="{ row }" field="Qty" label="Qty" class="field-ctn">
                            <strong>{{ row['count'] }}</strong>
                        </o-table-column>
                        <template>
                            <div v-for="col in tableColumns">
                              <o-table-column #default="{ row }" :field="col.field" :label="col.label" :key="col.field" class="field-ctn">
                                <strong>{{ row[col.field] }}</strong>
                              </o-table-column>
                            </div>
                        </template>
                    </template>
                    <template #detail="{ row }">
                        <tr v-for="item in row.items" :key="row.id + '_' + item.id">
                            <td v-if="table.detailed"></td>
                            <td/>
                            <td class="field-ctn" v-for="col in tableColumns" :key="row.id + '_' + item.id + '_' + col.field">
                                <span>{{ item[col.field] }}</span>
                            </td>
                        </tr>
                    </template>
                </o-table>
        </section>
        <footer class="modal-card-foot">
            <button class="button" type="button" @click="$parent.$parent.$emit('update:active', false)">Close</button>
        </footer>
    </div>
</template>

<script>

    export default {
        components: {
        },

        computed: {
            defaultOpenedDetails() {
                return this.data.map((i, idx) => idx)
            },

            total() {
                return !!this.data ? this.data.length : 0
            },

            transitionName() {
                if (this.useTransition) {
                    return 'fade'
                }
            },
        },

        data () {
            return {
                currentPage: 1,
                isReminderModalActive: false,
                isTableVisible: true,
                loading: false,
                table: {
                    bordered: false,
                    detailed: true,
                    hoverable: true,
                    mobileCards: true,
                    narrowed: false,
                    paginated: false,
                    paginationSimple: false,
                    perPage: 15,
                    perPageOptions: [5, 10, 15, 25, 50],
                    striped: true,
                },
                showDetailIcon: true,
                useTransition: false,
            }
        },

        mounted () {
        },

        methods: {
        },

        props: ['data', 'tableColumns', 'title'],

        watch: {
        },
    }
</script>

<style lang="sass" scoped>
.merged-contacts-modal
  width: 100% !important
  .filters-container
    align-items: center
    flex-wrap: wrap
  .merged-contacts-table
    .table-wrapper
      min-height: auto
      overflow-x: auto
      .field-ctn
        vertical-align: middle

</style>
